import React, { ReactElement } from "react";

import { colors } from "@lmc/common/constants";
import Avatar from "../../dataDisplay/Avatar";

export type AvatarLabelProps = {
  disabled?: boolean;
  label: string;
  labelStyle?: object;
  onSelect?: () => void;
  picture?: string;
  pictureStyle?: object;
  avatarSize?: number;
  className?: string;
  testId?: string;
};

export default function AvatarLabel({
  disabled,
  label,
  labelStyle,
  onSelect,
  picture,
  pictureStyle,
  avatarSize,
  className,
  testId,
}: AvatarLabelProps): ReactElement {
  if (!label) return <div style={styles.wrapper} />;

  const avatarStyle = {
    ...styles.profilePic,
    ...(disabled && { opacity: 0.2 }),
    ...pictureStyle,
  };

  const textStyle = {
    ...(!disabled && !!onSelect && { cursor: "pointer" }),
    ...(disabled && { color: colors.darkgrey }),
    ...labelStyle,
  };

  return (
    <div
      className={className}
      style={styles.wrapper}
      data-testid={testId || "avatar-label"}
    >
      <Avatar
        // @ts-ignore
        onClick={!disabled && onSelect}
        size={avatarSize || 46}
        style={avatarStyle}
        url={picture}
        data-testid={testId ? `${testId}-image` : "avatar-label-avatar"}
      />
      <div
        id="label"
        // @ts-ignore
        onClick={!disabled && onSelect}
        // @ts-ignore
        onKeyPress={!disabled && onSelect}
        role="link"
        style={textStyle}
        tabIndex={0}
        data-testid={testId ? `${testId}-label` : "avatar-label-text"}
      >
        {label}
      </div>
    </div>
  );
}

const styles = {
  label: {
    color: colors.black,
    display: "block",
    fontWeight: 600,
    marginTop: 12,
    overflowWrap: "anywhere",
  },
  profilePic: {
    marginRight: 12,
  },
  profilePicGreyed: {
    marginRight: 12,
    opacity: 0.2,
  },
  wrapper: {
    alignItems: "center",
    display: "flex",
    marginRight: 12,
  },
};
